import { Database, Settings, Users, Zap } from "lucide-react";
import { NichePage } from "./NichePageTemplate";

const sections = [
  {
    icon: Users,
    name: "Lead Management",
    items: ["Lead organization", "Lead tracking", "Follow-up systems", "Database management", "Lead pipelines"]
  },
  {
    icon: Settings,
    name: "Acquisitions",
    items: ["Acquisition workflow support", "Opportunity tracking", "Deal pipeline organization", "Research", "Documentation"]
  },
  {
    icon: Database,
    name: "CRM Operations",
    items: ["CRM organization", "Pipeline configuration", "Database cleanup", "Workflow management", "Automated follow-up"]
  },
  {
    icon: Zap,
    name: "Real Estate Operations",
    items: [
      "Investor operations", "Wholesaling workflows", "Land investing workflows",
      "Fix & flip operations", "Brokerage operations", "Property management operations",
      "Leasing workflows", "Administrative coordination"
    ]
  }
];

const technology = [
  "Podio", "REISift", "REI Reply", "GoHighLevel", "HubSpot", "Salesforce", "Zoho", "Zapier", "Make"
];

export const RealEstatePage = () => (
  <NichePage
    title="Real Estate Operations"
    subtitle="Operational infrastructure for modern real estate businesses."
    sections={sections}
    technology={technology}
  />
);
